export function getMetaTag(name){
  return document.querySelector(`head meta[name="${name}"]`)
}
